// extracted by mini-css-extract-plugin
export var textInput = "_lm-0";